import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('formular').directive('ttErrorMessages', ttErrorMessages);

    function ttErrorMessages($log) {
        $log.debug('Directive error started');
        return {
            restrict: 'E',
            link: function (scope, element, attrs) {
                $log.debug('Directive error run');
                scope.extraStyles = attrs.extraStyles;
            },
            template: require('app/_directives/error-messages.directive.html')
        };
    }
})();
